import LoadingSpinner from "../LoadingSpinner";
import { FactoryPathUrl } from "../../../utils/common";

interface LoadingStatesProps {
    loadingLogout: boolean;
    loginStatus: string;
    customerSitesLoading: boolean;
    FactoryPath: boolean;
    permittedCustomersLoading: boolean;
    permittedCustomersError: string;
    authLoading: boolean;
}

export default function LoadingStates({
    loadingLogout,
    loginStatus,
    customerSitesLoading,
    FactoryPath,
    permittedCustomersLoading,
    permittedCustomersError,
    authLoading
}: LoadingStatesProps) {
    const shouldShowLoading =
        !(loadingLogout === false && loginStatus === 'success' || customerSitesLoading ||
            (FactoryPathUrl(FactoryPath) && loadingLogout === false && loginStatus === 'success')) &&
        (permittedCustomersLoading && permittedCustomersError.length === 0 || authLoading);

    if (!shouldShowLoading) return null;

    return <LoadingSpinner />;
}
